/* eslint-disable no-restricted-syntax */
export enum renewalStatusEnum {
  Open = 1,
  Accepted = 2,
  Declined = 3,
  Ignored = 4, //TODO: this is a UI only status as a workaround for renewals behavior. Will need to handle better
}